import { consume } from '@lit/context';
import { localized, t } from '@weavedev/lit-i18next';
import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';

import { iconExclamationCircle } from '@/components/icons';
import { global, GlobalComponentType } from '@/context';
import { BREAKPOINT_MEDIUM_PX } from '@/settings';
import { baseStyles, buttonStyles, printProofStyles } from '@/styles';
import { openPrintProofDialog } from '../utils';

@customElement('fg-configuration-print-pending')
@localized()
export class FgConfigurationPrintPending extends LitElement {
  @consume({ context: global.context })
  globalContext!: GlobalComponentType;

  render() {
    const { layout } = this.globalContext;

    return html`
      <div class="status pending">
        <div class="message">
          ${iconExclamationCircle}
          <span>${t('content.printProof.statusPending')}</span>
        </div>
        <button
          class="button ${classMap({
            'button-secondary': layout === 'wholesale',
            'button-primary': layout === 'retail',
          })}"
          @click=${() => openPrintProofDialog(this)}
        >
          ${t('content.printProof.reviewPrintProof')}
        </button>
      </div>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    printProofStyles,
    css`
      .status {
        background-color: var(
          --fg-primary--light,
          var(--fg-fallback-primary--light)
        );
      }
      :host([part='retail']) .status {
        color: var(--fg-primary, var(--fg-fallback-primary));
      }
      :host([part='wholesale']) .status {
        color: var(--fg-secondary, var(--fg-fallback-secondary));
        border: 1px solid var(--fg-secondary, var(--fg-fallback-secondary));
      }
      .message {
        font-weight: 700;
      }
      .button {
        white-space: nowrap;
      }
      @media screen and (min-width: ${BREAKPOINT_MEDIUM_PX}px) {
        :host([part='retail']) .status {
          padding: 17px 24px;
        }

        :host([part='wholesale']) .status {
          padding: 14px 16px;
        }
      }
    `,
  ];
}
